/* global lang, navigator */
import React from 'react';
import Buttons from './Buttons';
import RemoteVideo from './RemoteVideo';
import RemoteVideoPlaceholder from './RemoteVideoPlaceholder';
import Chat from './Chat';

import './../css/Main.css';


export default class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: this.props.client,
      start: false,
      toId: '',
      initiator: null,
      disconnected: false,
      localVideo: null,
      time: false,
      isScreen: false,
      audioOn: true,
      configLoaded: false,
    };

    this.videoDevices = [];
    this.audioDevices = [];

    this.videoIndex = 0;
    this.audioIndex = 0;

    this.onConnected = this.onConnected.bind(this);
    this.onStrangerDisconnect = this.onStrangerDisconnect.bind(this);

    this.stream = null;
    this.localVideo = React.createRef();
    this.remoteVideo = React.createRef();

    this.videoDeviceId = false;
    this.audioDeviceId = false;
  }

  componentDidMount() {
    this.state.client.registerCommonHandler(this.onConnected, this.onStrangerDisconnect);
    this.getStream(this.state.client);

    console.log('mount mount')
    window.appEvents.on('endCall', () => {
      console.log('endCall')
      this.setState({
          toId: ''
        })
      
    });
    window.appEvents.on('projectConfigReceived', this.onConfigLoaded);
  }

  componentDidUpdate() {}

  componentWillUnmount() {
    this.state.client.unRegisterCommonHandler();
    window.appEvents.removeListener('projectConfigReceived', this.onConfigLoaded);
  }

  
  onConfigLoaded = (config) => {
    console.log('CONFIG LOADED')
    this.setState({
      configLoaded: true,
    })
  }

  onConnected({ toId, initiator, time, query }) {
    console.log('onConnected', toId, initiator, time, query)
    this.setState({ toId, initiator, time, query });
    window.appEvents.emit('infoUsers', query, toId);
  }

  async onStrangerDisconnect() {
    console.log('onStrangerDisconnect')
    await this.setState({ toId: '', initiator: null, disconnected: true });

    this.state.client.sendReady();

  }

  clickNext () {   
    this.state.client.stop(this.state.toId);
    this.setState({ start: false, toId: '', initiator: null, disconnected: false });
  }

  toogleStart() {
    //if (this.state.start) {
      //alert('ok2');
      //this.state.client.stop(this.state.toId);
      //this.setState({ start: false, toId: '', initiator: null, disconnected: false });
    /*}
    else {
      this.state.client.startSearch();
      this.setState({ start: true });
    }*/
  }

  getStream(client) {
    const gotMedia = stream => {
      this.setState({ localVideo: true });

      this.stream = stream;
      //console.log(client);
      this.updatePreview();

      navigator.mediaDevices.enumerateDevices().then((devices) => {
        for (var i = 0; i < devices.length; i++) {
          var device = devices[i];
          if (device.kind === 'videoinput') {
            let option = {};
            option.value = device.deviceId;
            option.text = device.label || 'camera ' + (i + 1);
            this.videoDevices.push(option);


          }
          else if (device.kind === 'audioinput') {
            let option = {};
            option.value = device.deviceId;
            option.text = device.label || 'microphone ' + (i + 1);
            this.audioDevices.push(option);

          }
        }
        this.forceUpdate();
      });

      client.sendReady();
    };

    navigator.getUserMedia =
      navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

    if (typeof navigator.mediaDevices.getUserMedia === 'undefined')
      navigator.mediaDevices.getUserMedia = navigator.getUserMedia; //({ video: true, audio: true }, gotMedia, () => this.setState({ localVideo: false }));
    //}
    //else {
	
	try {
		this.audioDeviceId = window.localStorage.getItem('audioDeviceId');
	}
	catch(err) {
		
	}
	try {
		this.videoDeviceId = window.localStorage.getItem('videoDeviceId');
	}
	catch(err) {
		
	}

    let constraints = { video: true, audio: true };

    if (this.audioDeviceId)
      constraints.audio = {
        deviceId: {
          exact: this.audioDeviceId
        }
      }

    if (this.videoDeviceId)
      constraints.video = {
        deviceId: {
          exact: this.videoDeviceId
        }
      }

  
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(gotMedia)
      .catch((err) => {
        console.log('err', err);
        this.setState({ localVideo: false }); /* alert('Please, accept the access of your webcam') */
      });
    //}
  }

  changeMic = (e) => {
    console.log(e.target.options[e.target.selectedIndex].value);
    this.audioIndex = e.target.selectedIndex;
	try {
		window.localStorage.setItem('audioDeviceId', this.audioDevices[this.audioIndex].value);
	}
	catch(err) {
	}
	
    this.audioDeviceId = this.audioDevices[this.audioIndex].value;
    this.updateSources('Audio');
  }

  changeCam = (e) => {
    console.log(e.target.options[e.target.selectedIndex].value);
    this.videoIndex = e.target.selectedIndex;
	try {
		window.localStorage.setItem('videoDeviceId', this.videoDevices[this.videoIndex].value);
	}
	catch(err) {
	}
	this.videoDeviceId = this.videoDevices[this.videoIndex].value;
    this.updateSources('Video');
  }

  startScreenCapture = async() => {

    if (!this.state.isScreen) {
      this.captureStream = await navigator.mediaDevices.getDisplayMedia({
          video: true
        })
        .catch(err => { console.error("Error:" + err); return null; });

      this.captureStream.getVideoTracks()[0].addEventListener('ended', () => {
        console.log('ended')
        this.setState({
          isScreen: false
        })
        this.updatePeer('Video');
      });

      this.setState({
        isScreen: true
      })

      this.updatePeer('Video', this.captureStream);
    }
    else {

      this.setState({
        isScreen: false
      })

      let tracks = this.captureStream.getTracks();
      for (let i in tracks) {
        console.log(tracks[i].kind + ' - stop')
        tracks[i].stop();
      }

      this.updatePeer('Video');
    }
  }

  async updateSources(kind) {

    this.stopSources();
	
	let constraints = { video: true, audio: true };
	
	console.log('UPDATE sources');
	
	if (this.audioDeviceId)
      constraints.audio = {
        deviceId: {
          exact: this.audioDeviceId
        }
      }

    if (this.videoDeviceId)
      constraints.video = {
        deviceId: {
          exact: this.videoDeviceId
        }
      }
	 
	 console.log(constraints);
    this.stream = await navigator.mediaDevices.getUserMedia(constraints)

    this.updatePreview();

    this.updatePeer2(kind);

  }

  updatePreview() {
    if ('srcObject' in this.localVideo.current) {
      this.localVideo.current.srcObject = this.stream;
    }
    else {
      this.localVideo.current.src = window.URL.createObjectURL(this.stream);
    }

    if (this.javascriptNode) {
      try {
        this.javascriptNode.disconnect(this.context.destination);
        this.javascriptNode = null;
      }
      catch (err) {

      }

      try {
        this.analyser.disconnect();
        this.analyser = null;
      }
      catch (err) {

      }

      try {
        this.microphone.disconnect();
        this.microphone = null;
      }
      catch (err) {

      }
    }
    
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new window.AudioContext();
    this.analyser = this.audioContext.createAnalyser();
    this.microphone = this.audioContext.createMediaStreamSource(this.stream);
    this.javascriptNode = this.audioContext.createScriptProcessor(2048, 1, 1);

    this.analyser.smoothingTimeConstant = 0.8;
    this.analyser.fftSize = 1024;

    this.microphone.connect(this.analyser);
    this.analyser.connect(this.javascriptNode);
    this.javascriptNode.connect(this.audioContext.destination);
    let vueMeter = document.querySelector('.vue-meter-inner');
    this.javascriptNode.onaudioprocess = () => {
      var array = new Uint8Array(this.analyser.frequencyBinCount);
      this.analyser.getByteFrequencyData(array);
      var values = 0;

      var length = array.length;
      for (var i = 0; i < length; i++) {
        values += (array[i]);
      }

      var average = values / length;
      
      vueMeter.style.height = Math.round(average) + '%';
      
    };

    //this.audioMixer.listenVolume(this.stream);

  }

  updatePeer(kind, stream = false) {

    if (this.remoteVideo && this.remoteVideo.current)
      this.remoteVideo.current.updatePeer(kind, !stream ? this.stream : stream);
  }
  
  updatePeer2(kind, stream = false) {

    if (this.remoteVideo && this.remoteVideo.current && this.remoteVideo.current.updatePeer) {
      this.remoteVideo.current.updatePeer('Audio', !stream ? this.stream : stream);      
	    this.remoteVideo.current.updatePeer('Video', !stream ? this.stream : stream);
    }
  }

  stopSources() {
    let tracks = this.stream.getTracks();
    for (let i in tracks) {
      console.log(tracks[i].kind + ' - stop')
      tracks[i].stop();
    }
  }
  
  toggleSourceChoice = () => {
    let display = document.querySelector('.sources-choice').style.display;
    if(display == 'none')
      document.querySelector('.sources-choice').style.display = 'block';
    else
      document.querySelector('.sources-choice').style.display = 'none';
  }

  toggleMute = () => {
    /*if (this.remoteVideo && this.remoteVideo.current && this.remoteVideo.current.mutePeer) {
      this.remoteVideo.current.mutePeer('Audio', !this.state.mute);    
      
    }*/
    let tracks = this.stream.getTracks();
    for (let i in tracks) {
      if(tracks[i].kind == 'audio') {
        console.log('mute', this.state.audioOn)
        tracks[i].enabled = !this.state.audioOn;
        this.setState({
          audioOn: !this.state.audioOn
        })
      }
    }
  }


  render() {

    const listVideoDevices = this.videoDevices.map((device) =>
      <option selected={ this.videoDeviceId == device.value ? 'selected': ''  } value={ device.value }>{ device.text }</option>
    );

    const listAudioDevices = this.audioDevices.map((device) =>
      <option selected={ this.audioDeviceId == device.value ? 'selected': ''  } value={ device.value }>{ device.text }</option>
    );

    return (
      <div className="main">
                
        <div className="video-area">
        
            {this.state.toId ? (
         
              <RemoteVideo
                client={this.state.client}
                toId={this.state.toId}
                initiator={this.state.initiator}
                stream={this.stream}
                time={this.state.time}
                ref={this.remoteVideo}
                name={this.state.query.name2}
              />
            ) : (
                <RemoteVideoPlaceholder
                  registerOnlineUsers={this.state.client.registerOnlineUsers}
                  getOnlineUsers={this.state.client.getOnlineUsers}
                  searching={!this.state.toId && this.state.start}
                  disconnected={this.state.disconnected}
                />
              )}
          
          <div id="local" className="video local">
            <div
              style={{
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              
              }}
            >
              <p className={'connectedname'}>{ this.state.query && this.state.query.name1 }</p>

              {this.state.localVideo ? (
                <video ref={this.localVideo} autoPlay muted playsInline></video>
              ) : (
                  <div>
                    { this.state.localVideo === null &&
                      <h3 dangerouslySetInnerHTML={{__html: lang.onboarding}}></h3>
                    }
                    
                    { this.state.localVideo === false &&
                      <h3 dangerouslySetInnerHTML={{__html: lang.webcam_error}}></h3>
                    }
                  </div>
                )}
            </div>
            <div className="vue-meter">
              <div className="vue-meter-inner"></div>
            </div>
            <div className="controls-right">
              <button className="btn icon icon-setting" onClick={ this.toggleSourceChoice  }><span dangerouslySetInnerHTML={{__html: lang.settings}}></span></button>
              <button className={`btn icon icon-audio ${this.state.audioOn ? 'icon-unmute' : 'icon-mute'}`} onClick={ this.toggleMute }>
                <span dangerouslySetInnerHTML={{__html: this.state.audioOn ? lang.mute : lang.unmute}}></span>
              </button>
            </div>
            <div className={ 'sources-choice' } style={{ display: 'none' }}>
              <div className="source-close" onClick={ this.toggleSourceChoice  }><svg width="20" height="20" viewbox="0 0 20 20"><path d="M 5,5 L 15,15 M 15,5 L 5,15" stroke="black" stroke-width="2" /></svg></div>
              <div className="source-item">
                <label dangerouslySetInnerHTML={{__html: lang.webcam}}></label>
                <select onChange={ this.changeCam } className="camera">
                  { listVideoDevices }
                </select>
              </div>
              <div className="source-item">
                <label dangerouslySetInnerHTML={{__html: lang.micro}}></label>
                <select onChange={ this.changeMic }>
                  { listAudioDevices }
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-area">
          <Buttons
            searching={!this.state.toId && this.state.start}
            connected={this.state.toId ? true : false}
            disconnected={this.state.disconnected}
            start={() => this.toogleStart()}
            next={() => this.clickNext()}
          />
          <Chat client={this.state.client} />
        </div>
        <div className="controls-left">
              <button className="btn btn-next" onClick={() => this.clickNext()}><span dangerouslySetInnerHTML={{__html: lang.meet_someone_else}}></span></button>
                  </div>
      </div>
    );
  }
}
